"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
exports.__esModule = true;
exports.TranslateDto = exports.IsLangAvailable = void 0;
var class_validator_1 = require("class-validator");
var constants_1 = require("../constants");
var languages = Object.keys(constants_1.LANGUAGE_MAP);
var IsLangAvailable = (function () {
    function IsLangAvailable() {
    }
    IsLangAvailable.prototype.validate = function (lang) {
        if (Array.isArray(lang)) {
            if (lang.length < 1 || lang.some(function (l) { return !languages.includes(l); }))
                return false;
        }
        else if (!languages.includes(lang))
            return false;
        return true;
    };
    IsLangAvailable = __decorate([
        class_validator_1.ValidatorConstraint({ name: 'isLangAvailable', async: false })
    ], IsLangAvailable);
    return IsLangAvailable;
}());
exports.IsLangAvailable = IsLangAvailable;
var TranslateDto = (function () {
    function TranslateDto() {
    }
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], TranslateDto.prototype, "from");
    __decorate([
        class_validator_1.Validate(IsLangAvailable, {
            message: 'Invalid language code'
        }),
        __metadata("design:type", Object)
    ], TranslateDto.prototype, "to");
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], TranslateDto.prototype, "text");
    return TranslateDto;
}());
exports.TranslateDto = TranslateDto;
//# sourceMappingURL=translate.dto.js.map